webpackJsonp([28],{

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'help-content',
	props: {
		content: {
			type: String,
			required: true
		},
		image: {
			type: String,
			default: ''
		},
		subTitle: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		isHtml: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1280);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(778)("75fe0796", content, true, {});

/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(777)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.img-help-container[data-v-505ceaf8]{height:auto;min-width:320px}.img-help-container .img-help[data-v-505ceaf8]{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/help/help-content.vue"],"names":[],"mappings":"AACA,WAAW,gCAAkC,kBAAkB,gBAAmB,wGAAwG,CACzL,AACD,WAAW,+BAAiC,kBAAkB,gBAAmB,kGAAkG,CAClL,AACD,WAAW,oCAAsC,kBAAkB,gBAAmB,0GAA0G,CAC/L,AACD,WAAW,2CAA6C,kBAAkB,gBAAmB,mHAAmH,CAC/M,AACD,WAAW,+BAAiC,kBAAkB,gBAAmB,kHAAkH,CAClM,AACD,WAAW,sCAAwC,kBAAkB,gBAAmB,+GAA+G,CACtM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kGAAkG,CAChL,AACD,WAAW,oCAAsC,kBAAkB,gBAAmB,2GAA2G,CAChM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kGAAkG,CAChL,AACD,WAAW,8BAAgC,kBAAkB,gBAAmB,mGAAmG,CAClL,AACD,WAAW,qCAAuC,kBAAkB,gBAAmB,6GAA6G,CACnM,AACD,WAAW,6BAA+B,kBAAkB,gBAAmB,kFAAmF,CACjK,AACD,qCAAqC,YAAY,eAAe,CAC/D,AACD,+CAA+C,YAAY,sBAAsB,mBAAmB,UAAU,CAC7G","file":"help-content.vue","sourcesContent":["\n@font-face{font-family:\"Avenir Next Regular\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Ultra Light\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Ultra Light Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Medium\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Medium Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Demi\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Demi Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Bold\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Heavy\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Heavy Italic\";font-style:normal;font-weight:normal;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")\n}\n@font-face{font-family:\"Avenir Next Book\";font-style:normal;font-weight:normal;src:local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))\n}\n.img-help-container[data-v-505ceaf8]{height:auto;min-width:320px\n}\n.img-help-container .img-help[data-v-505ceaf8]{height:100%;-o-object-fit:contain;object-fit:contain;width:100%\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{style:(("text-align:center;margin-bottom:20px;color:" + (_vm.globalColors.primary)))},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',{style:(("text-align:center;margin-bottom:40px;color:" + (_vm.globalColors.primary)))},[_vm._v(_vm._s(_vm.subTitle))]),_vm._v(" "),(_vm.isHtml)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('p',[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),(_vm.image)?_c('div',{staticClass:"img-help-container"},[_c('img',{staticClass:"img-help",attrs:{"src":_vm.image,"alt":"imagen"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_content_vue__ = __webpack_require__(1052);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ceaf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_content_vue__ = __webpack_require__(1281);
function injectStyle (ssrContext) {
  __webpack_require__(1279)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-505ceaf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ceaf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/28.fc889fd3077ee7fbf456.js